
export const MODULE_NAME = 'auth-module'

export const AUTH_ROUTES = {
  LAYOUT: MODULE_NAME,
  LOGIN: `${MODULE_NAME}.login`,
  LOGOUT: `${MODULE_NAME}.logout`,
} as const

export const getHash = (str: string) => {
  let hash = 0
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < str.length; i++) {
    const chr = str.charCodeAt(i)
    // eslint-disable-next-line no-bitwise
    hash = ((hash << 5) - hash) + chr
    // eslint-disable-next-line no-bitwise
    hash |= 0
  }

  return hash
}
